import React from "react";
import { Link } from "react-router-dom";
import {HashLink} from "react-router-hash-link";

// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  UncontrolledTooltip,
  NavLink,
  Button
} from "reactstrap";

function ScrollTransparentNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [navbarColor, setNavbarColor] = React.useState(
    (document.documentElement.scrollTop > 499 || document.body.scrollTop) > 499
      ? ""
      : " navbar-transparent"
  );
  const [buyButtonColor, setBuyButtonColor] = React.useState(
    (document.documentElement.scrollTop > 499 || document.body.scrollTop) > 499
      ? "info"
      : "neutral"
  );
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 499 ||
        document.body.scrollTop > 499
      ) {
        setNavbarColor("");
        setBuyButtonColor("info");
      } else if (
        document.documentElement.scrollTop < 500 ||
        document.body.scrollTop < 500
      ) {
        setNavbarColor(" navbar-transparent");
        setBuyButtonColor("neutral");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top"} color="dark" expand="lg" >
        <Container>
          <div className="navbar-translate">
            <NavbarBrand to="/" tag={Link} id="navbar-brand">
            <HashLink to="/index#index" smooth>  
              1HP Games
            </HashLink>
            </NavbarBrand>
            <UncontrolledTooltip target="navbar-brand">
              Simple Design | Great Fun
            </UncontrolledTooltip>
            <button
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse isOpen={collapseOpen} navbar>
            <Nav className="ml-auto" id="ceva" navbar>
              <NavItem>
                  <NavLink tag={Link} to="/games">
                  <i className="now-ui-icons design_app"></i>
                  <p>Games</p>
                  </NavLink>
              </NavItem>
              {/*
              <NavItem>
                <NavLink>
                <HashLink to="/index#team" smooth>
                <i className="now-ui-icons users_single-02"></i>
                  The Team
                </HashLink>  
                </NavLink>
              </NavItem>
            */}
              <NavItem>

                <NavLink>
                <i className="now-ui-icons ui-1_email-85"></i>
                  <a href="mailto:1hpgamesllc@gmail.com">Contact Us</a>
                  </NavLink>
              </NavItem>
              <NavItem>
              <HashLink to="/index#support" smooth>
              <Button
                  className="nav-link btn-round btn-primary"
                >
                  Support Us
                </Button>
                </HashLink>
                </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default ScrollTransparentNavbar;
